module.exports = __webpack_public_path__ + "static/media/display.d6d1aec8.mp4";